import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "transcript-assets" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = ["aria-label", "onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 3,
    class: "transcript-assets__caption"
};
import { ref } from "vue";
// Components
import SvgIcon from "@/common/components/SvgIcon.vue";
import RecDialog from "@/common/components/RecDialog.vue";
import MediaPlayer from "@/common/components/MediaPlayer.vue";
import { MediaPlayerStatus } from "@/types/media-player";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'TranscriptAssets',
    props: {
        assets: {}
    },
    setup(__props) {
        const activeVideo = ref(null);
        const playerOpen = ref(false);
        const openVideo = (asset) => {
            activeVideo.value = asset;
            playerOpen.value = true;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("ul", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.assets, (asset) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: asset.assetId,
                            class: "transcript-assets__item"
                        }, [
                            (asset.type === 'PHOTO' && asset.fileUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "transcript-assets__image",
                                    src: asset.fileUrl,
                                    alt: asset.caption || asset.filename || _ctx.$t('Image sent in chat')
                                }, null, 8, _hoisted_2))
                                : (asset.type === 'VIDEO' && asset.videoUrl)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "transcript-assets__video-thumb",
                                        "aria-label": asset.caption || asset.filename || _ctx.$t('Play video'),
                                        onClick: ($event) => (openVideo(asset))
                                    }, [
                                        (asset.posterImg)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "transcript-assets__poster",
                                                src: asset.posterImg,
                                                alt: ""
                                            }, null, 8, _hoisted_4))
                                            : _createCommentVNode("", true),
                                        _cache[2] || (_cache[2] = _createElementVNode("span", {
                                            class: "transcript-assets__play",
                                            "aria-hidden": "true"
                                        }, null, -1))
                                    ], 8, _hoisted_3))
                                    : (asset.fileUrl)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 2,
                                            class: "transcript-assets__file",
                                            href: asset.fileUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                        }, [
                                            _createVNode(SvgIcon, {
                                                icon: "icon-file",
                                                width: "1rem",
                                                height: "1rem"
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(asset.filename || _ctx.$t("File sent in chat")), 1)
                                        ], 8, _hoisted_5))
                                        : _createCommentVNode("", true),
                            (asset.caption)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(asset.caption), 1))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ]),
                _createVNode(RecDialog, {
                    modelValue: playerOpen.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((playerOpen).value = $event)),
                    "close-on-click-outside": "",
                    "close-on-escape": "",
                    onHide: _cache[1] || (_cache[1] = ($event) => (activeVideo.value = null))
                }, {
                    default: _withCtx(() => [
                        (activeVideo.value)
                            ? (_openBlock(), _createBlock(MediaPlayer, {
                                key: 0,
                                status: _unref(MediaPlayerStatus).Ready,
                                "stream-url": activeVideo.value.videoUrl,
                                "poster-url": activeVideo.value.posterImg,
                                "mime-type": "video/mp4"
                            }, null, 8, ["status", "stream-url", "poster-url"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
